// extracted by mini-css-extract-plugin
module.exports = {"onHoldContainer":"membershipbadge_onHoldContainer__3Uw-C","obliqueLineWrap":"membershipbadge_obliqueLineWrap__1TWq4","obliqueLine":"membershipbadge_obliqueLine__3MGl3"};